// ACTION REQUIRED: replace this with your real WhatsApp number.
// Use international format, digits only, NO "+".
// Example: Japan +81 90-1234-5678 -> "819012345678"
export const WHATSAPP_NUMBER = "819012345678";

export function buildWhatsAppUrl(id: string, headline: string, lang: string): string {
  const base = "https://wa.me/" + WHATSAPP_NUMBER;
  let text: string;
  if (lang === "ja") {
    text = `NORENさん、こんにちは。物件番号 ${id}（${headline}）に興味があります。詳しい資料をいただけますか？`;
  } else {
    text = `Hello NOREN, I'm interested in property ${id} (${headline}). Could you send me the full details?`;
  }
  return base + "?text=" + encodeURIComponent(text);
}